// Product mega-menu structure, derived from the single verticals source of truth
// (src/data/verticals.ts). Consumed by both the desktop mega-menu (Header) and
// the mobile menu so the two never drift. Each item carries its own image so the
// menu can swap the preview on hover.

import {
  verticals,
  verticalGroups,
  liveVertical,
  STATUS_LABEL,
} from './verticals'

export interface ProductMenuItem {
  slug: string
  title: string
  href: string
  image: string
  imageAlt: string
  statusLabel: string
}

export interface ProductMenuGroup {
  id: string
  title: string
  strapline: string
  items: ProductMenuItem[]
}

/** The one live vertical — anchors the menu and is the default preview image. */
export const productMenuFeatured: ProductMenuItem = {
  slug: liveVertical.slug,
  title: liveVertical.title,
  href: liveVertical.href,
  image: liveVertical.image,
  imageAlt: liveVertical.imageAlt,
  statusLabel: 'Available now',
}

/** Every other vertical, categorised by its group. */
export const productMenuGroups: ProductMenuGroup[] = verticalGroups.map((g) => ({
  id: g.id,
  title: g.title,
  strapline: g.strapline,
  items: verticals
    .filter((v) => v.group === g.id)
    .map((v) => ({
      slug: v.slug,
      title: v.title,
      href: `/verticals/${v.slug}`,
      image: v.image,
      imageAlt: v.imageAlt,
      statusLabel: STATUS_LABEL[v.status],
    })),
}))

/** Flat lookup (featured first) for resolving the hovered preview image. */
export const productMenuAll: ProductMenuItem[] = [
  productMenuFeatured,
  ...productMenuGroups.flatMap((g) => g.items),
]

export function getProductMenuItem(slug: string): ProductMenuItem {
  return productMenuAll.find((i) => i.slug === slug) ?? productMenuFeatured
}
